module.exports = __webpack_public_path__ + "static/media/student-summary-side.58c1b086.png";